module.exports = __webpack_public_path__ + "img/blend1Img.631aaffd.png";